import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n0 } from "../../lib/format";
import { Notice } from "../../lib/ui";
import "./mobile.css";

/*
 * Mobile money cash in / cash out – port of mobile_money.php + mm_process_transaction() (API: /api/mm/transactions)
 * Cash in: the customer pays cash and we send e-money, so the line's float goes down (refused if it would go below 0).
 * Cash out: the customer sends e-money and we pay cash, so the float goes up. Commission is recorded separately.
 */

const BLANK = { mno_account_id: "", txn_type: "cash_in", amount: "", commission: "0", customer_name: "", customer_phone: "", narrative: "" };

export default function MobileMoney({ user }) {
  const api = useApi();
  const [accounts, setAccounts] = useState(null);
  const [f, setF] = useState(BLANK);
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/api/mm/accounts", { active: 1 }).then((r) => setAccounts(r.accounts)).catch((e) => setResult({ tone: "err", text: e.message }));
  useEffect(() => { load(); }, [api]); // eslint-disable-line react-hooks/exhaustive-deps
  const acct = (accounts || []).find((a) => String(a.id) === String(f.mno_account_id));
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const short = f.txn_type === "cash_in" && acct && Number(f.amount) > Number(acct.current_float);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setResult(null);
    try {
      const r = await api.post("/api/mm/transactions", f);
      setResult({ tone: "ok", text: `Transaction recorded successfully. Reference No: ${r.reference_no}. New float: TZS ${n0(r.float_after)}.` });
      setF({ ...BLANK, mno_account_id: f.mno_account_id, txn_type: f.txn_type }); load();
    } catch (err) { setResult({ tone: "err", text: err.message }); }
    finally { setBusy(false); }
  };
  return (
    <main className="pg" style={{ maxWidth: "46rem" }}>
      <PageHeader slug="mobile_money" />
      <Notice notice={result} onClose={() => setResult(null)} />
      {accounts && accounts.length === 0 ? (
        <div className="ui-notice warn" style={{ display: "block" }}>No active MNO lines found. {user?.role === "admin" ? <>Go to <Link to="/mobile_money_float">MNO Lines &amp; Float</Link> to register one.</> : "Ask an administrator to register one."}</div>
      ) : (
        <form className="panel mm-form" onSubmit={submit}>
          <div className="mm-type" role="radiogroup" aria-label="Transaction type">
            {[["cash_in", "fa-arrow-down", "Cash In", "Customer deposits cash", "in"], ["cash_out", "fa-arrow-up", "Cash Out", "Customer withdraws cash", "out"]].map(([v, ic, l, s, cls]) => (
              <label key={v} className={`mm-type-opt ${cls} ${f.txn_type === v ? "on" : ""}`}>
                <input type="radio" name="txn_type" value={v} checked={f.txn_type === v} onChange={set("txn_type")} className="visually-hidden" />
                <i className={`fas ${ic}`} /><b>{l}</b><small>{s}</small></label>))}
          </div>
          <div className="field"><label htmlFor="mm-a">MNO line</label>
            <select id="mm-a" required value={f.mno_account_id} onChange={set("mno_account_id")}>
              <option value="">Select a line…</option>{(accounts || []).map((a) => <option key={a.id} value={a.id}>{a.operator} — {a.msisdn} ({a.business_name})</option>)}</select>
            {acct && <span className="hint">Current float: <b>TZS {n0(acct.current_float)}</b></span>}</div>
          <div className="mm-2">
            <div className="field"><label htmlFor="mm-amt">Amount (TZS)</label><input id="mm-amt" type="number" step="0.01" min="1" required value={f.amount} onChange={set("amount")} />
              {short && <span className="hint" style={{ color: "var(--danger)" }}>More than the float on this line.</span>}</div>
            <div className="field"><label htmlFor="mm-c">Commission (TZS)</label><input id="mm-c" type="number" step="0.01" min="0" value={f.commission} onChange={set("commission")} /></div>
          </div>
          <div className="mm-2">
            <div className="field"><label htmlFor="mm-n">Customer name (optional)</label><input id="mm-n" value={f.customer_name} onChange={set("customer_name")} /></div>
            <div className="field"><label htmlFor="mm-p">Customer phone (optional)</label><input id="mm-p" value={f.customer_phone} onChange={set("customer_phone")} /></div>
          </div>
          <div className="field"><label htmlFor="mm-note">Note (optional)</label><input id="mm-note" value={f.narrative} onChange={set("narrative")} /></div>
          <button type="submit" className="btn primary mm-submit" disabled={busy || short}><i className="fas fa-check" /> {busy ? "Recording…" : "Record transaction"}</button>
        </form>
      )}
    </main>
  );
}
